export default "Stratégie de vote en AG — Copropriétés | Solution Éco France";
